




































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconUpload, BIconBoxArrowRight } from "bootstrap-vue";
import Video from "@/components/Video.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconUpload,
    BIconBoxArrowRight,
    Video,
    NextPrevBtn,
    Footer,
  },
})
export default class AudioVisualFundamental extends Vue {
  protected videoVideo = [
    {
      videoSrc: "https://www.youtube.com/embed/PUPuemxfm2c",
      videoTitle: "Comment faire une capsule vidéo ?",
      videoRoot: "Chaîne : La classe de JJonet",
    },
    {
      videoSrc: "https://www.youtube.com/embed/YRQb8cHhwj0",
      videoTitle: "La capsule animée",
      videoRoot: " Chaîne : Jerome Blanstier",
    },
  ];
  protected nxtprevAudioVisualFundamental = {
    BoolPrev: false,
    BoolNext:  true,
    PrevImage: "",
    NextImage: "/thumbnail1.png",
    PrevLink: "",
    NextLink: "/Audiovisuel/Montage",
  };
}
